import viewpaths from "global/constants/ViewPathConstants";
import { currentPathname } from "./route-matcher";
import type { TourRouteParams } from "../types/tour.types";

type TourIdResolver = () => string | null | Promise<string | null>;

const segmentAfter = (prefix: string): string | null => {
  const path = currentPathname();
  const base = prefix.endsWith("/") ? prefix : `${prefix}/`;
  if (!path.startsWith(base)) return null;
  const segment = path.slice(base.length).split("/")[0];
  return segment ? decodeURIComponent(segment) : null;
};

const RESOLVERS: Record<string, TourIdResolver> = {
  currentRequestId: () => segmentAfter(viewpaths.viewRequestViewPath),
};

const messageOf = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);

export const resolveRouteParams = async (
  params: TourRouteParams | undefined,
): Promise<Record<string, string> | null> => {
  if (!params) return {};

  const resolved: Record<string, string> = {};

  for (const [name, source] of Object.entries(params)) {
    if (typeof source === "string") {
      resolved[name] = source;
      continue;
    }

    const resolver = RESOLVERS[source.resolver];
    if (!resolver) {
      console.warn(`Unknown tour id resolver: "${source.resolver}"`);
      return null;
    }

    try {
      const value = await resolver();
      if (!value) return null;
      resolved[name] = value;
    } catch (error) {
      console.warn(
        `Tour id resolver "${source.resolver}" failed:`,
        messageOf(error),
      );
      return null;
    }
  }

  return resolved;
};
